import { createSlice } from '@reduxjs/toolkit'
import {
  IsDeleteConfigurationAction,
  IsRenameConfigurationAction,
  IsSaveConfigurationAction,
  IsSaveDefaultConfigurationsAction,
  IsLoadConfigurationAction,
  AllFreeWidthColumn,
  Language_IT,
  IsSetConfigurationForMessageEvent,
  IsSaveArticles,
  AllOption,
  IsSetActiveStore,
  configurationEmptyTableOptions,
  configurationExtraDescription,
  configurationEmptyExtraDescription,
  configurationNegateTableColumns,
  configurationFilterSearch,
  configurationActiveFilters,
  EmptyFilterChecked,
  VariantModelValue,
  IsLoadProfileOptionsAction,
  IsSaveRowKeysAction,
  configurationPricelists,
  ModelKey,
  UiCodePricesOmnichannel,
} from '../../Constants/Configuration'
import {
  ArticleColumn,
  DefaultCols,
  defaultTableColumns,
  pricelists,
  defaultEmptyTableColumns,
  extraDescriptionLang,
  DefaultAlignedRightColumns,
  ArticleDefaultColumn,
} from '../../Constants/TableConfiguration'
import {
  mapDefaultPriceListFilters,
  mapWorkspaceTableColFilters,
  mapWorkspaceEmptyTableColumn,
  encryptLocalStorageValue,
  decryptLocalStorageValue,
  getStorageValue,
  setStorageValue,
  removeStorageValue,
  checkOmnichannelAndPricesVisibility,
} from '../../Helpers/ConfigurationHelper'
import {
  orderAndSetMarketplaceDefaultColumnFromData,
  orderAndSetMarketplaceFilterFromData,
  updateEmptyColumnTableFiltersValue,
} from '../../Helpers/FilterHelper'
import { isEmptyObject } from '../../Helpers/GenericHelpers'
import { WorkSpaces } from '../../Constants/WorkSpace'
import { IEditTag, ITag } from 'Services/Kiosk/TagsService'

export const tableOptionsSlice = createSlice({
  name: 'tableOptions',
  initialState: {
    sorting: {
      sortField: '',
      sortOrder: '',
      pageSize: 20,
      current: 1,
    },
    tableFilters: {} as any,
    tableFiltersTags: [] as ITag[],
    tableColumns: defaultTableColumns,
    pricelists: pricelists,
    emptyTableColumns: defaultEmptyTableColumns,
    negateTableColumns: [],
    freeWidthColumns: [],
    newLineColumns: [],
    alignLeftColumns: [],
    priceFilter: {} as any,
    emptyExtraDescriptions: [],
    alignRightColumns: DefaultAlignedRightColumns,
    showDrawer: false,
    priceList1: [],
    priceList2: [],
    fetchCount: true,
    count: 0,
    editTableDisable: true,
    editModalInfo: {
      showModal: false,
      columnName: '',
    },
    editContainerTags: [] as IEditTag[],
    activeAutocomplete: '',
    activeDropdown: '',
    activePriceDropdown: '',
    extraDescriptionLang: extraDescriptionLang,
    fullEditSelection: false,
    filterByAvailability: false,
    barcodeSearch: null,
    filterSearchCurrentValue: AllOption,
    defaultColumns: DefaultCols as ArticleDefaultColumn[],
    autocompleteValues: {},
    activeFilters: [],
  },
  reducers: {
    saveSorting: (state, action) => {
      if (action.payload.sortField) {
        state.sorting.sortField = action.payload.sortField
      } else {
        state.sorting.sortField = ''
      }
      if (action.payload.sortOrder) {
        state.sorting.sortOrder = action.payload.sortOrder
      } else {
        state.sorting.sortOrder = ''
      }
      if (action.payload.pageSize) {
        state.sorting.pageSize = action.payload.pageSize
      }
      if (action.payload.current) {
        state.sorting.current = action.payload.current || 1
      }
    },
    saveColumnsAndExtraColumns: (state, action) => {
      state.tableColumns = action.payload.tableColumns
      state.pricelists = action.payload.pricelists
      state.emptyTableColumns = action.payload.emptyTableColumns
      state.extraDescriptionLang = action.payload.extraDescriptionLang
      state.showDrawer = false
      action.payload.tableColumns.predefinedFilters.forEach(item => {
        if (!item.active) {
          delete state.tableFilters[item.value]
          delete state.autocompleteValues[item.value]
          if(item.value === ArticleColumn.Tag) {
            state.tableFiltersTags = [];
          }
          const elementIndex = state.negateTableColumns.indexOf(item.value)
          if (elementIndex !== -1) {
            state.negateTableColumns.splice(elementIndex, 1)
          }
          state.fetchCount = true
          if (state.barcodeSearch) {
            delete state.tableFilters[ArticleColumn.TableKey]
            state.barcodeSearch = null
          }
        }

        action.payload.emptyTableColumns.predefinedFilters.forEach(emptyFilter => {
          if (emptyFilter.value === item.value && emptyFilter.active) {
            const elementIndex = state.negateTableColumns.indexOf(item.value)
            if (elementIndex !== -1) {
              state.negateTableColumns.splice(elementIndex, 1)
            }
          }
        })
      })

      action.payload.tableColumns.extraFilters.forEach((item, index) => {
        if (!item.active) {
          delete state.tableFilters[item.value]
          delete state.autocompleteValues[item.value]
          const elementIndex = state.negateTableColumns.indexOf(item.value)
          if (elementIndex !== -1) {
            state.negateTableColumns.splice(elementIndex, 1)
          }
          state.fetchCount = true
        }

        action.payload.emptyTableColumns.extraFilters.forEach(emptyFilter => {
          if (emptyFilter.value === item.value && emptyFilter.active) {
            const elementIndex = state.negateTableColumns.indexOf(item.value)
            if (elementIndex !== -1) {
              state.negateTableColumns.splice(elementIndex, 1)
            }
          }
        })
      })

      action.payload.tableColumns.priceFilters.forEach((item, index) => {
        if (!item.active) {
          const priceFilterKeys = Object.keys(state.priceFilter)
          if (priceFilterKeys.length !== 0) {
            if (state.priceFilter.field === item.value) {
              if (!isEmptyObject(state.priceFilter)) {
                state.priceFilter = {}
              }
              state.fetchCount = true
            }
          }
        }
      })

      const activeFilters = action.payload.tableColumns.webAndMarketingFilters
        .filter(filter => filter.active)
        .concat(action.payload.tableColumns.predefinedFilters.filter(filter => filter.active))
        .concat(action.payload.tableColumns.extraFilters.filter(filter => filter.active))
        .concat(action.payload.tableColumns.optionalsFilters.filter(filter => filter.active))
        .concat(action.payload.tableColumns.priceFilters.filter(filter => filter.active))
      if (activeFilters.length !== 0) {
        state.activeFilters = activeFilters.map(x => x.value)
      }

      if (action.payload.tableColumns.webAndMarketingFilters.length !== 0 && action.payload.allMkt.length !== 0) {
        action.payload.tableColumns.webAndMarketingFilters.forEach((item, index) => {
          if (!item.active) {
            const market = action.payload.allMkt.find(x => item.value === x.alias || item.value === x.name)
            if (market) {
              delete state.tableFilters[market.column]
              state.fetchCount = true
            }
          }
        })
      }

      updateEmptyColumnTableFiltersValue(action.payload.emptyTableColumns, state.tableFilters)
    },
    removeColumn: (state, action) => {
      state.tableColumns.predefinedFilters.forEach(element => {
        if (element.value === action.payload) {
          element.active = false
          delete state.autocompleteValues[element.value]
          const elementIndex = state.negateTableColumns.indexOf(element.value)
          if (elementIndex !== -1) {
            state.negateTableColumns.splice(elementIndex, 1)
          }
          if (state.barcodeSearch) {
            delete state.tableFilters[ArticleColumn.TableKey]
            state.barcodeSearch = null
          }
        }
      })
      state.tableColumns.extraFilters.forEach(element => {
        if (element.value === action.payload) {
          element.active = false
          delete state.autocompleteValues[element.value]
          const elementIndex = state.negateTableColumns.indexOf(element.value)
          if (elementIndex !== -1) {
            state.negateTableColumns.splice(elementIndex, 1)
          }
        }
      })
      state.tableColumns.priceFilters.forEach(element => {
        if (element.value === action.payload) {
          element.active = false
        }
      })
      state.tableColumns.optionalsFilters.forEach(element => {
        if (element.value === action.payload) {
          element.active = false
        }
      })
      state.tableColumns.webAndMarketingFilters.forEach(element => {
        if (element.value === action.payload) {
          element.active = false
        }
      })

      const activeFilters = state.tableColumns.webAndMarketingFilters
        .filter(filter => filter.active)
        .concat(state.tableColumns.predefinedFilters.filter(filter => filter.active))
        .concat(state.tableColumns.extraFilters.filter(filter => filter.active))
        .concat(state.tableColumns.optionalsFilters.filter(filter => filter.active))
        .concat(state.tableColumns.priceFilters.filter(filter => filter.active))
      if (activeFilters.length !== 0) {
        state.activeFilters = activeFilters.map(x => x.value)
      }

      updateEmptyColumnTableFiltersValue(state.emptyTableColumns, state.tableFilters)
    },
    resetEmptyColumns: state => {
      const emptyTableColumnKeys = Object.keys(state.emptyTableColumns)
      emptyTableColumnKeys.forEach(key => {
        for (let element in state.tableColumns[key]) {
          state.emptyTableColumns[key].forEach(emptyElement => {
            if (emptyElement.value === state.tableColumns[key][element].value && emptyElement.active) {
              if (state.tableFilters[emptyElement.value]) {
                delete state.tableFilters[emptyElement.value]
              }
            }
          })
        }
      })

      state.emptyTableColumns = defaultEmptyTableColumns

      if (state.emptyExtraDescriptions.length !== 0) {
        state.emptyExtraDescriptions = []
      }

      //table count refresh because always reset
      state.fetchCount = true
      if (state.barcodeSearch) {
        delete state.tableFilters[ArticleColumn.TableKey]
        state.barcodeSearch = null
      }
    },
    resetSearchFilters: state => {
      Object.keys(state.tableFilters).forEach(key => {
        if (state.tableFilters[key] !== EmptyFilterChecked && state.negateTableColumns.indexOf(key) === -1) {
          delete state.tableFilters[key]
          delete state.autocompleteValues[key]
          
          state.tableFiltersTags = [];
        }
      })

      if (!isEmptyObject(state.priceFilter)) {
        state.priceFilter = {}
      }
      state.fetchCount = true
      state.barcodeSearch = null
    },
    setDrawerVisibility: (state, action) => {
      state.showDrawer = action.payload
    },
    savePricelist: (state, action) => {
      state.priceList1 = action.payload.data
      state.priceList2 = action.payload.data
      const isPricesOmichannelVisibile = action.payload.defaultProfileOptions.find(
        option =>
          option.uiCode === UiCodePricesOmnichannel &&
          checkOmnichannelAndPricesVisibility(action.payload.configurationName),
      )

      if (state.priceList1 && state.priceList1.length !== 0) {
        if (isPricesOmichannelVisibile?.active) {
          state.priceList1 = state.priceList1.filter(listElement => listElement.isVisibleInDiwa)
        }
      } else {
        //TODO da rivedere dopo decisione call 2751 su cosa fare nel caso in cui utente non ha listini abilitati
        state.priceList1 = [{ name: VariantModelValue, currencyDescription: '', currencySymbol: '' }]
      }
      if (state.priceList2 && state.priceList2.length !== 0) {
        if (isPricesOmichannelVisibile?.active) {
          state.priceList2 = state.priceList2.filter(listElement => listElement.isVisibleInDiwa)
        }
      } else {
        //TODO da rivedere dopo decisione call 2751 su cosa fare nel caso in cui utente non ha listini abilitati
        state.priceList1 = []
      }
    },
    saveFilters: (state, action) => {
      if (action.payload.key !== ModelKey) {
        state.tableFilters[ModelKey] = 0
      }
      if (action.payload.key !== ArticleColumn.TableKey) {
        state.tableFilters[ArticleColumn.TableKey] = 0
      }

      const isMultipleSearchField = DefaultCols.find(x => x.name === action.payload.key)?.multipleSearch
      if (isMultipleSearchField) {
        const searchedValues = state.tableFilters[action.payload.key] ?? ''
        const searchedSplitted = searchedValues.split('|')
        if (searchedSplitted.indexOf(action.payload.value) === -1) {
          const divider = searchedValues.length === 0 ? '' : '|'
          state.tableFilters[action.payload.key] = searchedValues.concat(divider, action.payload.value)
        }
      } else {
        state.tableFilters[action.payload.key] = action.payload.value
      }

      state.fetchCount = true
      if (state.barcodeSearch) {
        delete state.tableFilters[ArticleColumn.TableKey]
        state.barcodeSearch = null
      }

      if (action.payload.key === ArticleColumn.ProductCode) {
        state.tableColumns.predefinedFilters.forEach((item, index) => {
          if (item.value === ArticleColumn.ProductCode) {
            state.tableColumns.predefinedFilters[index].active = true
            if (state.activeFilters.indexOf(ArticleColumn.ProductCode) === -1) {
              state.activeFilters.push(ArticleColumn.ProductCode)
            }
          }
        })
      }
    },
    saveFilterTags:(state, action) => {
      //action.payload as ITag
      const tagStored = state.tableFiltersTags.find((x: ITag) => {
        return x.id === action.payload?.id
      });

      if(!tagStored) {
        state.tableFiltersTags.push(action.payload);
      }
    },
    removeFilterTags:(state, action) => {
      const tagStored = state.tableFiltersTags.find((x: ITag) => {
        return x.slug === action.payload
      });

      if(tagStored) {
        state.tableFiltersTags = state.tableFiltersTags.filter(x => x.slug !== action.payload);
      }
    },
    saveNegateColumns: (state, action) => {
      if (state.negateTableColumns.indexOf(action.payload) === -1) {
        state.negateTableColumns.push(action.payload)

        state.fetchCount = true
        if (state.barcodeSearch) {
          delete state.tableFilters[ArticleColumn.TableKey]
          state.barcodeSearch = null
        }
      }

      state.activeDropdown = state.activePriceDropdown = ''
    },
    resetNegateColumns: state => {
      state.negateTableColumns.forEach(element => {
        if (state.tableFilters[element]) {
          delete state.tableFilters[element]
          delete state.autocompleteValues[element]
        }
      })

      if (state.negateTableColumns.length !== 0) {
        state.negateTableColumns = []
      }

      state.fetchCount = true
      if (state.barcodeSearch) {
        delete state.tableFilters[ArticleColumn.TableKey]
        state.barcodeSearch = null
      }
    },
    removeFilter: (state, action) => {
      if (Object.keys(state.tableFilters).indexOf(action.payload) !== -1) {
        delete state.tableFilters[action.payload]
        delete state.autocompleteValues[action.payload]
        if(action.payload === ArticleColumn.Tag) {
          state.tableFiltersTags = [];
        }

        state.fetchCount = true
        if (state.barcodeSearch) {
          delete state.tableFilters[ArticleColumn.TableKey]
          state.barcodeSearch = null
        }
      }
    },
    removeNegateColumn: (state, action) => {
      const elementIndex = state.negateTableColumns.indexOf(action.payload)
      if (elementIndex !== -1) {
        state.negateTableColumns.splice(elementIndex, 1)

        state.fetchCount = true
        if (state.barcodeSearch) {
          delete state.tableFilters[ArticleColumn.TableKey]
          state.barcodeSearch = null
        }
      }
    },
    removeNegateColumnsAndAssociatedFilters: (state, action) => {
      const elementIndex = state.negateTableColumns.indexOf(action.payload)

      if (elementIndex !== -1) {
        state.negateTableColumns.splice(elementIndex, 1)

        if (Object.keys(state.tableFilters).indexOf(action.payload) !== -1) {
          delete state.tableFilters[action.payload]
          delete state.autocompleteValues[action.payload]
        }

        state.fetchCount = true
      }
    },
    saveFreeWidthColumn: (state, action) => {
      if (state.freeWidthColumns.indexOf(action.payload) === -1) {
        state.freeWidthColumns.push(action.payload)
      }

      state.activeDropdown = state.activePriceDropdown = ''
    },
    saveAllFreeWidthColumn: state => {
      const elementIndex = state.freeWidthColumns.indexOf(AllFreeWidthColumn)
      if (elementIndex === -1) {
        state.freeWidthColumns.push(AllFreeWidthColumn)
      }

      state.activeDropdown = state.activePriceDropdown = ''
    },
    resetFreeWidthColumns: state => {
      if (state.freeWidthColumns.length !== 0) {
        state.freeWidthColumns = []
      }

      state.activeDropdown = state.activePriceDropdown = ''
    },
    saveNewLineColumns: (state, action) => {
      const elementIndex = state.newLineColumns.indexOf(action.payload)
      if (elementIndex === -1) {
        state.newLineColumns.push(action.payload)
      } else {
        state.newLineColumns.splice(elementIndex, 1)
      }

      state.activeDropdown = state.activePriceDropdown = ''
    },
    setColumnToAlignLeft: (state, action) => {
      const elementIndex = state.alignLeftColumns.indexOf(action.payload)
      if (elementIndex === -1) {
        state.alignLeftColumns.push(action.payload)
      }
      const elementIndexRight = state.alignRightColumns.indexOf(action.payload)
      if (elementIndexRight !== -1) {
        state.alignRightColumns.splice(elementIndexRight, 1)
      }

      state.activeDropdown = state.activePriceDropdown = ''
    },
    setColumnToAlignRight: (state, action) => {
      const elementIndex = state.alignLeftColumns.indexOf(action.payload)
      if (elementIndex !== -1) {
        state.alignLeftColumns.splice(elementIndex, 1)
      }
      const elementIndexRight = state.alignRightColumns.indexOf(action.payload)
      if (elementIndexRight === -1) {
        state.alignRightColumns.push(action.payload)
      }

      state.activeDropdown = state.activePriceDropdown = ''
    },
    setColumnToUnAlign: (state, action) => {
      const elementIndex = state.alignLeftColumns.indexOf(action.payload)
      if (elementIndex !== -1) {
        state.alignLeftColumns.splice(elementIndex, 1)
      }
      const elementIndexRight = state.alignRightColumns.indexOf(action.payload)
      if (elementIndexRight !== -1) {
        state.alignRightColumns.splice(elementIndexRight, 1)
      }

      state.activeDropdown = state.activePriceDropdown = ''
    },
    updateEmptyColumn: (state, action) => {
      const emptyTableColumnKeys = Object.keys(state.emptyTableColumns)

      emptyTableColumnKeys.forEach(key => {
        for (let element in state.tableColumns[key]) {
          state.emptyTableColumns[key].forEach(emptyElement => {
            if (emptyElement.value === action.payload.value) {
              if (emptyElement.value === state.tableColumns[key][element].value) {
                emptyElement.active = action.payload.active
                state.fetchCount = true
                if (state.barcodeSearch) {
                  delete state.tableFilters[ArticleColumn.TableKey]
                  state.barcodeSearch = null
                }

                if (!action.payload.active && state.tableFilters[action.payload.value]) {
                  delete state.tableFilters[action.payload.value]
                  delete state.autocompleteValues[action.payload.value]
                  if(action.payload.value === ArticleColumn.Tag) {
                    state.tableFiltersTags = [];
                  }
                }
              }
            }
          })
        }
      })
    },
    toggleEditTable: state => {
      state.editTableDisable = !state.editTableDisable
      if (state.fullEditSelection) {
        state.fullEditSelection = false
      }
    },
    showEditModal: (state, action) => {
      state.editModalInfo = {
        showModal: true,
        columnName: action.payload,
      }

      state.activeDropdown = state.activePriceDropdown = ''
    },
    hideEditModal: state => {
      state.editModalInfo = {
        showModal: false,
        columnName: '',
      }
    },
    setActiveAutocomplete: (state, action) => {
      state.activeAutocomplete = action.payload

      state.activeDropdown = state.activePriceDropdown = ''
    },
    setActiveDropdown: (state, action) => {
      state.activeDropdown = state.activeDropdown === action.payload ? '' : action.payload

      if (state.activeAutocomplete !== '') {
        state.activeAutocomplete = ''
      }
    },
    setActivePriceDropdown: (state, action) => {
      state.activePriceDropdown = state.activePriceDropdown === action.payload ? '' : action.payload

      if (state.activeAutocomplete !== '') {
        state.activeAutocomplete = ''
      }
    },
    addPriceFilter: (state, action) => {
      state.priceFilter = action.payload
      state.fetchCount = true
      if (state.barcodeSearch) {
        delete state.tableFilters[ArticleColumn.TableKey]
        state.barcodeSearch = null
      }
    },
    addEmptyDescription: (state, action) => {
      state.emptyExtraDescriptions.push(action.payload)
      state.fetchCount = true
      if (state.barcodeSearch) {
        delete state.tableFilters[ArticleColumn.TableKey]
        state.barcodeSearch = null
      }

      state.activeDropdown = state.activePriceDropdown = ''
    },
    setFullEditSelection: (state, action) => {
      state.fullEditSelection = action.payload
    },
    toggleAvailabilityFilter: state => {
      state.filterByAvailability = !state.filterByAvailability
      if (state.barcodeSearch) {
        delete state.tableFilters[ArticleColumn.TableKey]
        state.barcodeSearch = null
      }
      state.fetchCount = true
    },
    clearTagFilters: (state, action) => {
      if (!isEmptyObject(state.tableFilters)) {
        state.tableFilters = {}
      }
      if (!isEmptyObject(state.autocompleteValues)) {
        state.autocompleteValues = {}
      }
      if(state.tableFiltersTags.length !== 0) {
        state.tableFiltersTags = [];
      }
      state.barcodeSearch = null
      if (!isEmptyObject(state.priceFilter)) {
        state.priceFilter = {}
      }
      if (state.emptyExtraDescriptions.length !== 0) {
        state.emptyExtraDescriptions = []
      }

      //action.payload is current configuration name
      if (action.payload.configurationName !== action.payload.publicWorkspace) {
        const storedNegateTableColumns = decryptLocalStorageValue(
          action.payload.configurationName + configurationNegateTableColumns,
          action.payload.user,
          action.payload.serverConfig,
        )

        state.emptyTableColumns = mapWorkspaceEmptyTableColumn(
          action.payload.configurationName,
          defaultEmptyTableColumns,
          action.payload.user,
          action.payload.serverConfig,
        )

        updateEmptyColumnTableFiltersValue(state.emptyTableColumns, state.tableFilters)

        state.negateTableColumns = storedNegateTableColumns ? JSON.parse(storedNegateTableColumns) : []
      } else {
        state.emptyTableColumns = defaultEmptyTableColumns
        if (state.negateTableColumns.length !== 0) {
          state.negateTableColumns = []
        }
      }

      state.fetchCount = true
    },
    resetDynamicLabelToInitial: (state, action) => {
      if (state.tableFilters[action.payload.label]) {
        delete state.tableFilters[action.payload.label]
        if(action.payload.label === ArticleColumn.Tag) {
          state.tableFiltersTags = [];
        }
      }

      if (action.payload.columnEmpty) {
        const emptyTableColumnKeys = Object.keys(state.emptyTableColumns)
        emptyTableColumnKeys.forEach(key => {
          for (let element in state.tableColumns[key]) {
            state.emptyTableColumns[key].forEach(emptyElement => {
              if (emptyElement.value === action.payload.label) {
                if (emptyElement.value === state.tableColumns[key][element].value) {
                  emptyElement.active = false

                  if (state.tableFilters[action.payload.label]) {
                    delete state.tableFilters[action.payload.label]
                  }
                }
              }
            })
          }
        })
      }

      if (action.payload.specialLanguageFilter) {
        state.emptyExtraDescriptions = state.emptyExtraDescriptions.filter(desc => {
          return desc.field !== action.payload.label || desc.languageCode !== action.payload.languageCode
        })
      }

      state.activeAutocomplete = ''
      state.fetchCount = true
    },
    setEmptyColumnFromMenu: (state, action) => {
      const elementIndex = state.negateTableColumns.indexOf(action.payload)
      if (elementIndex !== -1) {
        state.negateTableColumns.splice(elementIndex, 1)
      }

      if (state.tableFilters[action.payload]) {
        delete state.tableFilters[action.payload]
      }

      state.emptyTableColumns.predefinedFilters.forEach((item, index) => {
        if (item.value === action.payload) {
          state.emptyTableColumns.predefinedFilters[index].active = true

          state.fetchCount = true
        }
      })
      state.emptyTableColumns.extraFilters.forEach((item, index) => {
        if (item.value === action.payload) {
          state.emptyTableColumns.extraFilters[index].active = true

          state.fetchCount = true
        }
      })

      updateEmptyColumnTableFiltersValue(state.emptyTableColumns, state.tableFilters)

      state.activeDropdown = state.activePriceDropdown = ''
    },
    saveBarcode: (state, action) => {
      state.tableFilters = { [action.payload.key]: action.payload.value }
      if (state.negateTableColumns.length !== 0) {
        state.negateTableColumns = []
      }
      if (!isEmptyObject(state.priceFilter)) {
        state.priceFilter = {}
      }
      if (state.emptyExtraDescriptions.length !== 0) {
        state.emptyExtraDescriptions = []
      }
      state.emptyTableColumns = defaultEmptyTableColumns

      if (state.editModalInfo.showModal) {
        state.editModalInfo = {
          showModal: false,
          columnName: '',
        }
      }

      if (state.showDrawer) {
        state.showDrawer = false
      }

      if (!state.editTableDisable) {
        state.editTableDisable = true
        if (state.fullEditSelection) {
          state.fullEditSelection = false
        }
      }

      state.fetchCount = true
      state.barcodeSearch = action.payload.barCode
    },
    setFilterSearchValue: (state, action) => {
      state.filterSearchCurrentValue = action.payload.dropdownFilterValue
      state.fetchCount = true

      state.editTableDisable = true
      state.fullEditSelection = false
    },
    updateMarketplaceColumnsFilter: (state, action) => {
      if (action.payload.mktAlias && action.payload.mktAlias.length !== 0) {
        state.tableColumns.webAndMarketingFilters = orderAndSetMarketplaceFilterFromData(action.payload.mktAlias)
      }
    },
    updateDefaultColumns: (state, action) => {
      //marketplace need to be set after fields filter
      const indexToSetNewItems = state.defaultColumns.findIndex(obj => obj.name === ArticleColumn.Field10)
      const arrayToSet: ArticleDefaultColumn[] = [...DefaultCols]
      if (indexToSetNewItems !== -1) {
        if (action.payload.mktAlias && action.payload.mktAlias.length !== 0) {
          const reorderedMrkp = orderAndSetMarketplaceDefaultColumnFromData(action.payload.mktAlias)

          reorderedMrkp.forEach((marketplaceEl, index) => {
            arrayToSet.splice(indexToSetNewItems + index + 1, 0, marketplaceEl)
          })
        }
        state.defaultColumns = arrayToSet
      }
    },
    setAutocompleteValues: (state, action) => {
      state.autocompleteValues[action.payload.label] = action.payload.text
    },
    updateMultipleSearchFilters: (state, action) => {
      const searchedValues = state.tableFilters[action.payload.key] ?? ''
      const searchedSplitted = searchedValues.split('|')
      if (searchedSplitted.indexOf(action.payload.value) !== -1) {
        state.tableFilters[action.payload.key] = searchedSplitted.filter(x => x !== action.payload.value).join('|')
      }
    },
    resetAlignedColumns: state => {
      state.alignLeftColumns = []
      state.alignRightColumns = DefaultAlignedRightColumns
    },
    setEditContainerTags: (state, action) => {
      state.editContainerTags = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(IsLoadConfigurationAction, (state, action) => {
        const profileOptions = action.payload.defaultProfileOptions ? action.payload.defaultProfileOptions : []

        state.editTableDisable = true
        state.fullEditSelection = false

        const storedExtraDescriptionLangOptions = decryptLocalStorageValue(
          action.payload.configurationName + configurationExtraDescription,
          action.payload.user,
          action.payload.serverConfig,
        )
        const storedEmptyExtraDescription = decryptLocalStorageValue(
          action.payload.configurationName + configurationEmptyExtraDescription,
          action.payload.user,
          action.payload.serverConfig,
        )
        const storedNegateTableColumns = decryptLocalStorageValue(
          action.payload.configurationName + configurationNegateTableColumns,
          action.payload.user,
          action.payload.serverConfig,
        )
        const storedFilterSearch = decryptLocalStorageValue(
          action.payload.configurationName + configurationFilterSearch,
          action.payload.user,
          action.payload.serverConfig,
        )
        const storedActiveFilters = decryptLocalStorageValue(
          action.payload.configurationName + configurationActiveFilters,
          action.payload.user,
          action.payload.serverConfig,
        )

        const storedPriceList = decryptLocalStorageValue(
          action.payload.configurationName + configurationPricelists,
          action.payload.user,
          action.payload.serverConfig,
        )

        const mappedFilter = mapWorkspaceTableColFilters(
          action.payload.configurationName,
          profileOptions,
          state.tableColumns,
          action.payload.user,
          action.payload.serverConfig,
        )
        state.tableColumns = mappedFilter

        state.emptyTableColumns = mapWorkspaceEmptyTableColumn(
          action.payload.configurationName,
          defaultEmptyTableColumns,
          action.payload.user,
          action.payload.serverConfig,
        )
        state.extraDescriptionLang = storedExtraDescriptionLangOptions
          ? JSON.parse(storedExtraDescriptionLangOptions)
          : extraDescriptionLang
        state.emptyExtraDescriptions = storedEmptyExtraDescription ? JSON.parse(storedEmptyExtraDescription) : []
        state.negateTableColumns = storedNegateTableColumns ? JSON.parse(storedNegateTableColumns) : []
        state.filterSearchCurrentValue = storedFilterSearch ? storedFilterSearch : AllOption
        state.activeFilters = storedActiveFilters ? JSON.parse(storedActiveFilters) : []
        state.pricelists = storedPriceList
          ? JSON.parse(storedPriceList)
          : mapDefaultPriceListFilters(JSON.parse(JSON.stringify(state.pricelists)), VariantModelValue)

        Object.entries(state.tableColumns).forEach(group => {
          group[1].forEach(option => {
            if (state.activeFilters.indexOf(option.value) !== -1) {
              option['active'] = state.activeFilters.indexOf(option.value) !== -1
            }
          })
        })

        state.fetchCount = true

        updateEmptyColumnTableFiltersValue(state.emptyTableColumns, state.tableFilters)
      })
      .addMatcher(IsLoadProfileOptionsAction, (state, action) => {
        state.editTableDisable = true
        state.fullEditSelection = false

        const presetMarketplaceColumns = [...state.tableColumns.webAndMarketingFilters]
        const tableColumnsToSet = mapWorkspaceTableColFilters(
          action.payload.configurationName,
          action.payload.defaultProfileOptions,
          defaultTableColumns,
          action.payload.user,
          action.payload.serverConfig,
        )
        state.tableColumns = tableColumnsToSet
        state.pricelists = mapDefaultPriceListFilters(JSON.parse(JSON.stringify(state.pricelists)))

        //this condition is verified if getOptions service start after setMarketplaceFilters service (this trigger only on application start)
        if (
          presetMarketplaceColumns.length !== 0 &&
          action.payload.allMarketplace &&
          action.payload.allMarketplace.length === 0
        ) {
          state.tableColumns.webAndMarketingFilters = presetMarketplaceColumns
        } else {
          if (action.payload.allMarketplace && action.payload.allMarketplace.length !== 0) {
            state.tableColumns.webAndMarketingFilters = orderAndSetMarketplaceFilterFromData(
              action.payload.allMarketplace,
            )
          }
        }

        state.emptyTableColumns = defaultEmptyTableColumns
        const extraDescriptions = JSON.parse(JSON.stringify(extraDescriptionLang))
        state.tableColumns.extraFilters.forEach(filter => {
          if (
            filter.value === ArticleColumn.ShortDescription ||
            filter.value === ArticleColumn.SpecialDescription ||
            filter.value === ArticleColumn.Description ||
            filter.value === ArticleColumn.SizeAndFit
          ) {
            if (filter.active) {
              if (extraDescriptions[Language_IT].indexOf(filter.value) !== -1) {
                extraDescriptions[Language_IT].push(filter.value)
              }
            }
          }
        })

        const preservedExtraDescriptionLang = JSON.parse(JSON.stringify(state.extraDescriptionLang))
        const preservedEmptyExtraDescriptions = JSON.parse(JSON.stringify(state.emptyExtraDescriptions))

        state.extraDescriptionLang = extraDescriptions
        if (state.emptyExtraDescriptions.length !== 0) {
          state.emptyExtraDescriptions = []
        }
        state.filterSearchCurrentValue = AllOption
        state.fetchCount = true

        if (state.pricelists.priceList1.length === 0) state.pricelists.priceList1 = VariantModelValue

        if (state.activeFilters.length > 0) {
          Object.entries(state.tableColumns).forEach((group: any) => {
            group[1].forEach(option => {
              option['active'] = state.activeFilters.indexOf(option.value) !== -1
            })
          })

          state.extraDescriptionLang = preservedExtraDescriptionLang
          state.emptyExtraDescriptions = preservedEmptyExtraDescriptions
        }
      })
      .addMatcher(IsSaveConfigurationAction, (state, action) => {
        const activeEmptyFilter = state.emptyTableColumns.predefinedFilters
          .filter(x => x.active)
          .concat(state.emptyTableColumns.extraFilters.filter(x => x.active))

        const activeFilters = state.tableColumns.webAndMarketingFilters
          .filter(filter => filter.active)
          .concat(state.tableColumns.predefinedFilters.filter(filter => filter.active))
          .concat(state.tableColumns.extraFilters.filter(filter => filter.active))
          .concat(state.tableColumns.optionalsFilters.filter(filter => filter.active))
          .concat(state.tableColumns.priceFilters.filter(filter => filter.active))

        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationEmptyTableOptions,
          JSON.stringify(activeEmptyFilter?.map(x => x.value) ?? []),
          action.payload.user,
          action.payload.serverConfig,
        )

        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationExtraDescription,
          JSON.stringify(state.extraDescriptionLang),
          action.payload.user,
          action.payload.serverConfig,
        )

        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationEmptyExtraDescription,
          JSON.stringify(state.emptyExtraDescriptions),
          action.payload.user,
          action.payload.serverConfig,
        )

        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationNegateTableColumns,
          JSON.stringify(state.negateTableColumns),
          action.payload.user,
          action.payload.serverConfig,
        )

        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationFilterSearch,
          state.filterSearchCurrentValue,
          action.payload.user,
          action.payload.serverConfig,
        )

        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationActiveFilters,
          JSON.stringify(activeFilters?.map(x => x.value) ?? []),
          action.payload.user,
          action.payload.serverConfig,
        )

        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationPricelists,
          JSON.stringify(state.pricelists),
          action.payload.user,
          action.payload.serverConfig,
        )
      })
      .addMatcher(IsSaveDefaultConfigurationsAction, (state, action) => {
        if (action.payload.publicWorkspace) {
          const space = WorkSpaces[action.payload.publicWorkspace]
          encryptLocalStorageValue(
            action.payload.publicWorkspace + configurationEmptyTableOptions,
            JSON.stringify(space[configurationEmptyTableOptions.substring(1)]),
            action.payload.user,
            action.payload.serverConfig,
          )
          encryptLocalStorageValue(
            action.payload.publicWorkspace + configurationExtraDescription,
            JSON.stringify(space[configurationExtraDescription.substring(1)]),
            action.payload.user,
            action.payload.serverConfig,
          )
          encryptLocalStorageValue(
            action.payload.publicWorkspace + configurationEmptyExtraDescription,
            JSON.stringify(space[configurationEmptyExtraDescription.substring(1)]),
            action.payload.user,
            action.payload.serverConfig,
          )
          encryptLocalStorageValue(
            action.payload.publicWorkspace + configurationNegateTableColumns,
            JSON.stringify(space[configurationNegateTableColumns.substring(1)]),
            action.payload.user,
            action.payload.serverConfig,
          )
          encryptLocalStorageValue(
            action.payload.publicWorkspace + configurationFilterSearch,
            space[configurationFilterSearch.substring(1)],
            action.payload.user,
            action.payload.serverConfig,
          )
          encryptLocalStorageValue(
            action.payload.publicWorkspace + configurationActiveFilters,
            JSON.stringify(space[configurationActiveFilters.substring(1)]),
            action.payload.user,
            action.payload.serverConfig,
          )
          encryptLocalStorageValue(
            action.payload.publicWorkspace + configurationPricelists,
            JSON.stringify(space[configurationPricelists.substring(1)]),
            action.payload.user,
            action.payload.serverConfig,
          )
        } else {
          for (const [key, value] of Object.entries(WorkSpaces)) {
            encryptLocalStorageValue(
              key + configurationEmptyTableOptions,
              JSON.stringify(value[configurationEmptyTableOptions.substring(1)]),
              action.payload.user,
              action.payload.serverConfig,
            )
            encryptLocalStorageValue(
              key + configurationExtraDescription,
              JSON.stringify(value[configurationExtraDescription.substring(1)]),
              action.payload.user,
              action.payload.serverConfig,
            )
            encryptLocalStorageValue(
              key + configurationEmptyExtraDescription,
              JSON.stringify(value[configurationEmptyExtraDescription.substring(1)]),
              action.payload.user,
              action.payload.serverConfig,
            )
            encryptLocalStorageValue(
              key + configurationNegateTableColumns,
              JSON.stringify(value[configurationNegateTableColumns.substring(1)]),
              action.payload.user,
              action.payload.serverConfig,
            )
            encryptLocalStorageValue(
              key + configurationFilterSearch,
              value[configurationFilterSearch.substring(1)],
              action.payload.user,
              action.payload.serverConfig,
            )
            encryptLocalStorageValue(
              key + configurationActiveFilters,
              JSON.stringify(value[configurationActiveFilters.substring(1)]),
              action.payload.user,
              action.payload.serverConfig,
            )
            encryptLocalStorageValue(
              key + configurationPricelists,
              JSON.stringify(value[configurationPricelists.substring(1)]),
              action.payload.user,
              action.payload.serverConfig,
            )
          }
        }
      })
      .addMatcher(IsDeleteConfigurationAction, (state, action) => {
        removeStorageValue(
          action.payload.configurationName + configurationEmptyTableOptions,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.configurationName + configurationExtraDescription,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.configurationName + configurationEmptyExtraDescription,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.configurationName + configurationNegateTableColumns,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.configurationName + configurationFilterSearch,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.configurationName + configurationActiveFilters,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.configurationName + configurationPricelists,
          action.payload.user,
          action.payload.serverConfig,
        )
      })
      .addMatcher(IsRenameConfigurationAction, (state, action) => {
        const oldEmptyTableOptionsValue = getStorageValue(
          action.payload.before + configurationEmptyTableOptions,
          action.payload.user,
          action.payload.serverConfig,
        )
        const oldDescriptionLangOptions = getStorageValue(
          action.payload.before + configurationExtraDescription,
          action.payload.user,
          action.payload.serverConfig,
        )
        const oldEmptyExtraDescription = getStorageValue(
          action.payload.before + configurationEmptyExtraDescription,
          action.payload.user,
          action.payload.serverConfig,
        )
        const oldNegateTableColumns = getStorageValue(
          action.payload.before + configurationNegateTableColumns,
          action.payload.user,
          action.payload.serverConfig,
        )
        const oldFilterSearch = getStorageValue(
          action.payload.before + configurationFilterSearch,
          action.payload.user,
          action.payload.serverConfig,
        )
        const oldActiveFilters = getStorageValue(
          action.payload.before + configurationActiveFilters,
          action.payload.user,
          action.payload.serverConfig,
        )
        const oldPricelists = getStorageValue(
          action.payload.before + configurationPricelists,
          action.payload.user,
          action.payload.serverConfig,
        )

        setStorageValue(
          action.payload.after + configurationEmptyTableOptions,
          action.payload.user,
          action.payload.serverConfig,
          oldEmptyTableOptionsValue,
        )
        setStorageValue(
          action.payload.after + configurationExtraDescription,
          action.payload.user,
          action.payload.serverConfig,
          oldDescriptionLangOptions,
        )
        setStorageValue(
          action.payload.after + configurationEmptyExtraDescription,
          action.payload.user,
          action.payload.serverConfig,
          oldEmptyExtraDescription,
        )
        setStorageValue(
          action.payload.after + configurationNegateTableColumns,
          action.payload.user,
          action.payload.serverConfig,
          oldNegateTableColumns,
        )
        setStorageValue(
          action.payload.after + configurationFilterSearch,
          action.payload.user,
          action.payload.serverConfig,
          oldFilterSearch,
        )
        setStorageValue(
          action.payload.after + configurationActiveFilters,
          action.payload.user,
          action.payload.serverConfig,
          oldActiveFilters,
        )
        setStorageValue(
          action.payload.after + configurationPricelists,
          action.payload.user,
          action.payload.serverConfig,
          oldPricelists,
        )

        removeStorageValue(
          action.payload.before + configurationEmptyTableOptions,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.before + configurationExtraDescription,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.before + configurationEmptyExtraDescription,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.before + configurationNegateTableColumns,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.before + configurationFilterSearch,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.before + configurationActiveFilters,
          action.payload.user,
          action.payload.serverConfig,
        )
        removeStorageValue(
          action.payload.before + configurationPricelists,
          action.payload.user,
          action.payload.serverConfig,
        )
      })
      .addMatcher(IsSaveRowKeysAction, (state, action) => {
        if (state.fullEditSelection) {
          state.fullEditSelection = false
        }
      })
      .addMatcher(IsSetConfigurationForMessageEvent, (state, action) => {
        state.emptyTableColumns = defaultEmptyTableColumns
        if (!isEmptyObject(state.tableFilters)) {
          state.tableFilters = {}
        }
        if (!isEmptyObject(state.autocompleteValues)) {
          state.autocompleteValues = {}
        }
        if(state.tableFiltersTags.length !== 0) {
          state.tableFiltersTags = [];
        }
        if (state.negateTableColumns.length !== 0) {
          state.negateTableColumns = []
        }
      })
      .addMatcher(IsSaveArticles, (state, action) => {
        if (state.count !== action.payload.count) {
          state.count = action.payload.count
        }

        state.fetchCount = false
      })
      .addMatcher(IsSetActiveStore, (state, action) => {
        state.fetchCount = true
        state.editTableDisable = true
        state.fullEditSelection = false
      })
  },
})

// Action creators are generated for each case reducer function
export const {
  saveSorting,
  saveColumnsAndExtraColumns,
  setDrawerVisibility,
  savePricelist,
  saveFilters,
  saveFilterTags,
  removeFilterTags,
  resetSearchFilters,
  saveNegateColumns,
  resetNegateColumns,
  resetEmptyColumns,
  removeColumn,
  removeFilter,
  removeNegateColumn,
  updateEmptyColumn,
  saveFreeWidthColumn,
  saveAllFreeWidthColumn,
  resetFreeWidthColumns,
  setColumnToAlignLeft,
  setColumnToAlignRight,
  setColumnToUnAlign,
  toggleEditTable,
  hideEditModal,
  showEditModal,
  setActiveAutocomplete,
  setActiveDropdown,
  setActivePriceDropdown,
  addPriceFilter,
  addEmptyDescription,
  setFullEditSelection,
  toggleAvailabilityFilter,
  saveNewLineColumns,
  clearTagFilters,
  removeNegateColumnsAndAssociatedFilters,
  resetDynamicLabelToInitial,
  setEmptyColumnFromMenu,
  saveBarcode,
  setFilterSearchValue,
  updateMarketplaceColumnsFilter,
  updateDefaultColumns,
  setAutocompleteValues,
  updateMultipleSearchFilters,
  resetAlignedColumns,
  setEditContainerTags,
} = tableOptionsSlice.actions

export default tableOptionsSlice.reducer
